// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_ey-0";